module.exports = __webpack_public_path__ + "static/media/onogate-extra-1.b6103ba0.png";